const cmsConstants = {
  List_Removal: "ptc_lst_removal_header",
  Header_Content: "ptc_lst_removal_header_content",
  Please_Unsubscribe: "ptc_lst_removal_unsubscribe_content",
  Required_Fields: "ptc_lst_removal_required_fields_content",
  Email: "ptc_lst_removal_email_checkbox",
  Postal_Mail: "ptc_lst_removal_postalmail_checkbox",
  Phone: "ptc_lst_removal_phone_checkbox",
  Mobile: "ptc_lst_removal_mobile_checkbox",
  Mobile_Number: "ptc_lst_removal_mobile_phone_label",
  Fax: "ptc_lst_removal_fax_checkbox",
  Fax_Number: "ptc_lst_removal_fax_number_label",
  Email_Address: "ptc_lst_removal_email_address_label",
  WhatsApp: "ptc_lst_removal_whatsapp_checkbox",
  WhatsApp_Phone:"ptc_lst_removal_phone_number_label",
  Country: "ptc_lst_removal_country_label",
  countries: "ptc_lst_countries",
  Company_Name: "ptc_lst_removal_company_name_label",
  Street_Address: "ptc_lst_removal_street_address_label",
  Address_Line2: "ptc_lst_removal_address_line_2",
  Add_Address: "ptc_lst_removal_add_another_address",
  City: "ptc_lst_removal_city_label",
  State: "ptc_lst_removal_state_label",
  Zip_Code: "ptc_lst_removal_zip_code_label",
  Work_Phone: "ptc_lst_removal_work_phone_label",
  Home_Phone: "ptc_lst_removal_home_phone",
  Add_Extension: "ptc_lst_removal_add_extension_label",
  Extension: "ptc_lst_removal_extension_label",
  First_Name: "ptc_lst_removal_first_name_label",
  Last_Name: "ptc_lst_removal_last_name_label",
  Footer_Content: "ptc_lst_removal_footer_content",
  Privacy_Policy: "ptc_lst_removal_privacy_content",
  Cancel: "ptc_lst_removal_cancel_button",
  preference_management_center: "ptc_lst_removal_preference_management",
  privacy_statement: "ptc_lst_removal_privacy_statement",
  unsubscribe: "ptc_lst_removal_unsubscribe_link",
  address_suggestions: "ptc_lst_removal_add_suggest",
  verified_address: "ptc_list_removal_verified_address",
  use_this_address: "ptc_list_removal_this_address",
  address_suggestion_not_found: "ptc_list_removal_address_notfound",
  your_entry: "ptc_list_removal_your_entry",
  use_original_address: "ptc_list_removal_original_address",
  successfully_unsubscribed: "ptc_list_removal_validation_unsubscribe",
  failed_unsubscribe: "ptc_list_failure",
  opted_out_marketing_communication: "ptc_list_removal_post_mail_comm",
  validation_email: "ptc_list_removal_email_address",
  valIdation_city: "ptc_list_removal_your_city",
  validation_select_state: "ptc_list_removal_a_state",
  validation_first_name: "ptc_list_removal_first_name",
  validation_last_name: "ptc_list_validate_lastname",
  validation_street_address: "ptc_list_removal_street_address",
  validation_zip_code: "ptc_list_removal_zip_code",
  validation_home_phone: "ptc_list_validate_homephone",
  validation_phone: "ptc_list_validate_phone",
  validation_mobile: "ptc_list_validate_mobile",
  validation_fax: "ptc_list_validate_fax",
  validation_street_addr: "ptc_list_validate_street",
  State_Province_Region: "ptc_list_state_lbl",
  validate_email: "ptc_list_validate_email",
  List_Removal_Months: "ptc_lst_months_weeks",
  List_Removal_Days: "ptc_lst_removal_bussiness_days",
  SMS: "ptc_lst_removal_sms_checkbox",
  SMS_Number: "ptc_lst_removal_sms_number_label",
  validation_SMS: "ptc_list_validate_sms",
};
export default cmsConstants;
